export const wabaForEu = (builder) => ({
    wabaForEu: builder.mutation({
    query: ({ user_id = ''}) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/user_waba_phones', 
                method: 'GET',
                params: {user_id},
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            }
        },
    }),
});